import Component from '@bythepixel/component-loader';
import { EVENT_NAMES as YOUTUBE_EVENTS } from '@Core/components/youtubeLivestream/events';
import { Events } from './events';
import { LAYOUT_MAPPING, selectors } from './config';

export default class FloatingElementManager extends Component {
  static selector = '[data-comp-floating-element-manager]';

  layout;
  youtubeContainer;

  showingLivestream = false;

  constructor(containerEl) {
    super(containerEl);
    this.layoutName = containerEl.dataset.layout;
    this.youtubeContainer = containerEl.querySelector(
      selectors.youtubeContainer,
    );

    this.initLayout();
    this.mount();
  }

  initLayout() {
    const LayoutClass = this.layoutName
      ? LAYOUT_MAPPING[this.layoutName]
      : LAYOUT_MAPPING.default;

    if (!LayoutClass) return;

    this.layout = new LayoutClass(this.$container);
    this.layout?.mount();
  }

  attachListeners() {
    window.addEventListener(YOUTUBE_EVENTS.MAXIMIZED, () => {
      this.$container.dataset.livestreamMaximized = true;
    });

    window.addEventListener(YOUTUBE_EVENTS.MINIMIZED, () => {
      this.$container.dataset.livestreamMaximized = false;
    });

    window.addEventListener(YOUTUBE_EVENTS.ACTIVATED, () => {
      this.showingLivestream = true;
      this.$container.dataset.livestreamActive = true;
    });

    window.addEventListener(YOUTUBE_EVENTS.DISMISSED, () => {
      this.showingLivestream = false;
      this.$container.dataset.livestreamActive = false;
    });
  }

  isLayout(layoutName) {
    return this.layoutName === layoutName;
  }

  topEdgePosition() {
    return this.layout.topEdgePosition();
  }

  watch(callback, observerOptions = {}) {
    const observer = new MutationObserver((mutations, _observer) => {
      callback(mutations, _observer);
    });

    const options = {
      attributes: true,
      childList: true,
      subtree: true,
      ...observerOptions,
    };

    observer.observe(this.$container, options);
  }

  mount() {
    this.attachListeners();
    window.dispatchEvent(Events.Mounted(this));
  }
}
